import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomLink from 'components/Common/CustomLink/CustomLink';
import ModalForgotCustomerNumber from 'components/Modals/ModalForgotCustomerNumber/ModalForgotCustomerNumber';

export type Props = {
  classes: Partial<{
    wrapper: string;
    link: string;
  }>;
};

export default function ForgotCustomerNumberLink({
  classes,
}: Props): JSX.Element {
  const { t } = useTranslation(['loginPage']);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className={classes?.wrapper}>
        <CustomLink
          to="#"
          className={classes?.link}
          onClick={() => setOpenModal(true)}
        >
          {t('LABEL_FORGOT_CUSTOMER_NUMBER')}
        </CustomLink>
      </div>
      {openModal && (
        <ModalForgotCustomerNumber
          isOpen={true}
          closeModal={() => setOpenModal(false)}
        />
      )}
    </>
  );
}
